import { render, staticRenderFns } from "./CardListDashboard.vue?vue&type=template&id=65377fa3&"
import script from "./CardListDashboard.vue?vue&type=script&lang=js&"
export * from "./CardListDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports